<template>
  <div class="KimmuShusei">
    <el-dialog :title="dialogTitle" :visible="isShuseiDialogVisible" :show-close="false" @open="onOpen" width="1120px" top="8vh">
      <el-form id="KimmuShuseiForm" ref="KimmuShuseiForm" :model="form" label-width="85px" v-loading="loading" size="medium">
        <table id="KimmuShuseiTable">
          <tr>
            <th></th>
            <th>始業時刻</th>
            <th>終業時刻</th>
            <th>昼食時間</th>
            <th>休憩時間</th>
            <th>時間外<br/>移動時間</th>
            <th>基準時間内</th>
            <th>通常残業</th>
            <th v-if="isK">日曜日</th>
            <th>土・祝日</th>
            <th v-if="!isK">日曜日</th>
            <th>深夜勤務</th>
            <th>基準時間未満</th>
            <th>通勤手当</th>
            <th>ルート外<br/>交通費</th>
          </tr>
          <tr>
            <th>元データ</th>
            <td>{{form.shigyoJikoku}}</td>
            <td>{{form.shugyoJikoku}}</td>
            <td>{{form.chushokuJikan}}</td>
            <td>{{form.kyukeiJikan}}</td>
            <td>{{form.jikanGaiIdoJikan}}</td>
            <td>{{form.kijunJikanNaiKimmu}}</td>
            <td>{{form.tsujoZangyo}}</td>
            <td v-if="isK">{{form.nichiyoKimmu}}</td>
            <td>{{form.doyoShukujitsuKimmu}}</td>
            <td v-if="!isK">{{form.nichiyoKimmu}}</td>
            <td>{{form.shinyaKimmu}}</td>
            <td>{{form.kijunJikanMiman}}</td>
            <td>{{form.tsukinTeate}}</td>
            <td>{{form.kotsuhi}}</td>
          </tr>
          <tr>
            <th style="width:80px;">修正データ</th>
            <td>
              <el-input v-model="form.shusei.shigyoJikoku" type="text" maxlength="5" @blur="toHankaku('shigyoJikoku')"></el-input>
            </td>
            <td>
              <el-input v-model="form.shusei.shugyoJikoku" type="text" maxlength="5" @blur="toHankaku('shugyoJikoku')"></el-input>
            </td>
            <td>
              <el-input v-model="form.shusei.chushokuJikan" type="text" maxlength="5" @blur="toHankaku('chushokuJikan')"></el-input>
            </td>
            <td>
              <el-input v-model="form.shusei.kyukeiJikan" type="text" maxlength="5" @blur="toHankaku('kyukeiJikan')"></el-input>
            </td>
            <td>
              <el-input v-model="form.shusei.jikanGaiIdoJikan" type="text" maxlength="5" @blur="toHankaku('jikanGaiIdoJikan')"></el-input>
            </td>
            <td>
              <el-input v-model="form.shusei.kijunJikanNaiKimmu" type="text" maxlength="5" @blur="toHankaku('kijunJikanNaiKimmu')"></el-input>
            </td>
            <td>
              <el-input v-model="form.shusei.tsujoZangyo" type="text" maxlength="5" @blur="toHankaku('tsujoZangyo')"></el-input>
            </td>
            <td v-if="isK">
              <el-input v-model="form.shusei.nichiyoKimmu" type="text" maxlength="5" @blur="toHankaku('nichiyoKimmu')"></el-input>
            </td>
            <td>
              <el-input v-model="form.shusei.doyoShukujitsuKimmu" type="text" maxlength="5" @blur="toHankaku('doyoShukujitsuKimmu')"></el-input>
            </td>
            <td v-if="!isK">
              <el-input v-model="form.shusei.nichiyoKimmu" type="text" maxlength="5" @blur="toHankaku('nichiyoKimmu')"></el-input>
            </td>
            <td>
              <el-input v-model="form.shusei.shinyaKimmu" type="text" maxlength="5" @blur="toHankaku('shinyaKimmu')"></el-input>
            </td>
            <td>
              <el-input v-model="form.shusei.kijunJikanMiman" type="text" maxlength="5" @blur="toHankaku('kijunJikanMiman')"></el-input>
            </td>
            <td style="width: 80px;">
              <el-input v-model="form.shusei.tsukinTeate" type="text" maxlength="6" @blur="toHankaku('tsukinTeate', true)"></el-input>
            </td>
            <td style="width: 80px;">
              <el-input v-model="form.shusei.kotsuhi" type="text" maxlength="6" @blur="toHankaku('kotsuhi', true)"></el-input>
            </td>
          </tr>
        </table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onRegister">修正登録</el-button>
        <el-button type="danger" @click="onDelete">修正取消</el-button>
        <el-button @click="onCancel">キャンセル</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { notifySuccess, notifyError } from '../utils.js'

export default {
  name: 'KimmuShusei',
  props: ['isShuseiDialogVisible', 'shuseiShainId', 'shuseiNengetsu', 'shuseiRow', 'isK'],
  data() {
    return {
      form: {
        kimmuBi: '',
        shainId: '',
        shigyoJikoku: '',
        shugyoJikoku: '',
        shugyoJikokuHyoji: '',
        chushokuJikan: '',
        kyukeiJikan: '',
        jikanGaiIdoJikan: '',
        kijunJikanNaiKimmu: '',
        tsujoZangyo: '',
        doyoShukujitsuKimmu: '',
        nichiyoKimmu: '',
        shinyaKimmu: '',
        kijunJikanMiman: '',
        tsukinTeate: '',
        kotsuhi: '',
        shusei: {
          shainId: '',
          kimmuBi: '',
          kimmuBiNo: '',
          nengetsu: '',
          shigyoJikoku: '',
          shugyoJikoku: '',
          shugyoJikokuHyoji: '',
          chushokuJikan: '',
          kyukeiJikan: '',
          jikanGaiIdoJikan: '',
          kijunJikanNaiKimmu: '',
          tsujoZangyo: '',
          doyoShukujitsuKimmu: '',
          nichiyoKimmu: '',
          shinyaKimmu: '',
          kijunJikanMiman: '',
          tsukinTeate: '',
          kotsuhi: '',
        }
      },
      isUpdate: false,
      loading: true,
    }
  },
  computed: {
    dialogTitle() {
      return `${this.shuseiRow.kimmuBi}の勤務実績修正`;
    },
  },
  methods: {
    onOpen() {
      this.isUpdate = false;
      this.form.shainId = this.shuseiShainId;
      this.form.shigyoJikoku = this.shuseiRow.shigyoJikoku;
      this.form.shugyoJikoku = this.shuseiRow.shugyoJikoku;
      this.form.chushokuJikan = this.shuseiRow.chushokuJikan;
      this.form.kyukeiJikan = this.shuseiRow.kyukeiJikan;
      this.form.jikanGaiIdoJikan = this.shuseiRow.jikanGaiIdoJikan;
      this.form.kijunJikanNaiKimmu = this.shuseiRow.kijunJikanNaiKimmu;
      this.form.tsujoZangyo = this.shuseiRow.tsujoZangyo;
      this.form.doyoShukujitsuKimmu = this.shuseiRow.doyoShukujitsuKimmu;
      this.form.nichiyoKimmu = this.shuseiRow.nichiyoKimmu;
      this.form.shinyaKimmu = this.shuseiRow.shinyaKimmu;
      this.form.kijunJikanMiman = this.shuseiRow.kijunJikanMiman;
      this.form.tsukinTeate = this.shuseiRow.tsukinTeate;
      this.form.kotsuhi = this.shuseiRow.kotsuhi;
      this.form.shusei.shainId = this.shuseiShainId;
      this.form.shusei.kimmuBi = this.shuseiRow.kimmuBiDisplay;
      this.form.shusei.kimmuBiNo = this.shuseiRow.kimmuBiNo;
      this.form.shusei.kimmuBiJisseki = this.shuseiRow.kimmuBi;
      this.form.shusei.nengetsu = this.shuseiNengetsu;
      if (this.shuseiRow.shusei) {
        this.form.shusei.shigyoJikoku = this.shuseiRow.shusei.shigyoJikoku;
        this.form.shusei.shugyoJikoku = this.shuseiRow.shusei.shugyoJikoku;
        this.form.shusei.chushokuJikan = this.shuseiRow.shusei.chushokuJikan;
        this.form.shusei.kyukeiJikan = this.shuseiRow.shusei.kyukeiJikan;
        this.form.shusei.jikanGaiIdoJikan = this.shuseiRow.shusei.jikanGaiIdoJikan;
        this.form.shusei.kijunJikanNaiKimmu = this.shuseiRow.shusei.kijunJikanNaiKimmu;
        this.form.shusei.tsujoZangyo = this.shuseiRow.shusei.tsujoZangyo;
        this.form.shusei.doyoShukujitsuKimmu = this.shuseiRow.shusei.doyoShukujitsuKimmu;
        this.form.shusei.nichiyoKimmu = this.shuseiRow.shusei.nichiyoKimmu;
        this.form.shusei.shinyaKimmu = this.shuseiRow.shusei.shinyaKimmu;
        this.form.shusei.kijunJikanMiman = this.shuseiRow.shusei.kijunJikanMiman;
        this.form.shusei.tsukinTeate = this.shuseiRow.shusei.tsukinTeate;
        this.form.shusei.kotsuhi = this.shuseiRow.shusei.kotsuhi;
      } else {
        this.form.shusei.shigyoJikoku = '';
        this.form.shusei.shugyoJikoku = '';
        this.form.shusei.chushokuJikan = '';
        this.form.shusei.kyukeiJikan = '';
        this.form.shusei.jikanGaiIdoJikan = '';
        this.form.shusei.kijunJikanNaiKimmu = '';
        this.form.shusei.tsujoZangyo = '';
        this.form.shusei.doyoShukujitsuKimmu = '';
        this.form.shusei.nichiyoKimmu = '';
        this.form.shusei.shinyaKimmu = '';
        this.form.shusei.kijunJikanMiman = '';
        this.form.shusei.tsukinTeate = '';
        this.form.shusei.kotsuhi = '';
      }
      this.toHankaku('shigyoJikoku');
      this.toHankaku('shugyoJikoku');
      this.toHankaku('chushokuJikan');
      this.toHankaku('kyukeiJikan');
      this.toHankaku('jikanGaiIdoJikan');
      this.toHankaku('kijunJikanNaiKimmu');
      this.toHankaku('tsujoZangyo');
      this.toHankaku('doyoShukujitsuKimmu');
      this.toHankaku('nichiyoKimmu');
      this.toHankaku('shinyaKimmu');
      this.toHankaku('kijunJikanMiman');
      this.toHankaku('tsukinTeate');
      this.toHankaku('kotsuhi');
      this.loading = false;
    },
    onRegister() {
      this.$confirm(this.shuseiRow.kimmuBi + 'の修正情報を登録します。よろしいですか？', '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        type: 'info'
      }).then(() => {
        this.loading = true;
        let params = new URLSearchParams();
        params.append('shainId', this.form.shusei.shainId ?? '');
        params.append('kimmuBi', this.form.shusei.kimmuBi ?? '');
        params.append('kimmuBiNo', this.form.shusei.kimmuBiNo ?? 0);
        params.append('kimmuBiJisseki', this.form.shusei.kimmuBiJisseki ?? '');
        params.append('nengetsu', this.form.shusei.nengetsu ?? '');
        params.append('shigyoJikoku', this.form.shusei.shigyoJikoku ?? '');
        params.append('shugyoJikoku', this.form.shusei.shugyoJikoku ?? '');
        params.append('chushokuJikan', this.form.shusei.chushokuJikan ?? '');
        params.append('kyukeiJikan', this.form.shusei.kyukeiJikan ?? '');
        params.append('jikanGaiIdoJikan', this.form.shusei.jikanGaiIdoJikan ?? '');
        params.append('kijunJikanNaiKimmu', this.form.shusei.kijunJikanNaiKimmu ?? '');
        params.append('tsujoZangyo', this.form.shusei.tsujoZangyo ?? '');
        params.append('doyoShukujitsuKimmu', this.form.shusei.doyoShukujitsuKimmu ?? '');
        params.append('nichiyoKimmu', this.form.shusei.nichiyoKimmu ?? '');
        params.append('shinyaKimmu', this.form.shusei.shinyaKimmu ?? '');
        params.append('kijunJikanMiman', this.form.shusei.kijunJikanMiman ?? '');
        params.append('tsukinTeate', this.form.shusei.tsukinTeate ?? '');
        params.append('kotsuhi', this.form.shusei.kotsuhi ?? '');
        this.$axios.post('/gwr/kimmu/kimmuShusei', params)
            .then(() => {
              notifySuccess(this, '登録完了', '修正情報を登録しました。');
              this.isUpdate = true;
              this.onClose();
            })
            .catch((error) => {
              notifyError(this, error, 'データ登録エラー');
            });
      });
    },
    onDelete() {
      this.$confirm(this.shuseiRow.kimmuBi + 'の修正情報を削除します。よろしいですか？', '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        type: 'info'
      }).then(() => {
        this.loading = true;
        this.$axios.delete(`/gwr/kimmu/kimmuShusei/${this.form.shusei.kimmuBi}/${this.form.shusei.kimmuBiNo}/${this.form.shusei.shainId}`)
            .then(() => {
              notifySuccess(this, '削除完了', '修正情報を削除しました。');
              this.isUpdate = true;
              this.onClose();
            })
            .catch((error) => {
              notifyError(this, error, 'データ削除エラー');
            });
      });
    },
    onCancel() {
      this.onClose();
    },
    onClose() {
      this.$emit('close-shusei-dialog', this.isUpdate);
    },
    toHankaku(prop, nopad) {
      if (this.form.shusei[prop]) {
        let value = this.form.shusei[prop].replace(/[０-９：]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
        if (!nopad) {
          this.form.shusei[prop] = value.padStart(5, '0');
        }
      }
    },
  }
}
</script>

<style scoped>
.el-button {
  margin: 0px 1px !important;
}
#KimmuShuseiForm >>> .half-input {
  width: 110px !important;
}
#KimmuShuseiForm >>> .el-input__inner {
  font-family: inherit !important;
}
.KimmuShusei >>> .el-dialog__body {
  padding-top: 10px !important;
  padding-bottom: 0 !important;
}
#KimmuShuseiTable {
  border-collapse:  collapse;
}
#KimmuShuseiTable th {
  border-style: solid;
  border-width: 1px;
  text-align: center;
  padding: 4px 3px;
  font-family: 'Avenir', Helvetica, Arial, sans-serif, Osaka;
  font-size: 14px;
  border-color: lightgray;
  background-color: #F5F7FA;
  color: #606266;
}
#KimmuShuseiTable td {
  border-style: solid;
  border-width: 1px;
  text-align: center;
  padding: 2px 3px;
  font-family: 'Avenir', Helvetica, Arial, sans-serif, Osaka;
  font-size: 14px;
  border-color: lightgray;
  color: #606266;
}
</style>